import React from 'react';
import { Globe, Palette, TrendingUp, Shield, Megaphone, Sparkles } from 'lucide-react';
import { services } from '../data/mock';
import { ScrollReveal, StaggerContainer } from './ScrollAnimations';

const iconMap = {
  Globe: Globe,
  Palette: Palette,
  TrendingUp: TrendingUp,
  Shield: Shield,
  Megaphone: Megaphone,
  Sparkles: Sparkles,
};

const ExpertiseSection = () => {
  return (
    <section id="expertise" className="relative bg-black py-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02]" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <ScrollReveal animation="fadeUp">
            <span className="text-accent text-sm font-medium tracking-wider uppercase mb-4 block">
              Notre expertise
            </span>
          </ScrollReveal>
          <ScrollReveal animation="fadeUp" delay={100}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6">
              Des solutions digitales complètes
            </h2>
          </ScrollReveal>
          <ScrollReveal animation="fadeUp" delay={200}>
            <p className="text-white/50 text-lg max-w-2xl mx-auto">
              De la conception à la mise en ligne, nous vous accompagnons à chaque étape de votre projet digital.
            </p>
          </ScrollReveal>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <ScrollReveal 
                key={service.id} 
                animation="fadeUp" 
                delay={index * 100}
                className="group relative p-8 bg-white/[0.02] border border-white/[0.05] hover:border-accent/30 hover:bg-white/[0.04] transition-all duration-500"
              >
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center bg-accent/10 text-accent mb-6 group-hover:bg-accent group-hover:text-black transition-all duration-500">
                  {IconComponent && <IconComponent size={24} />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-accent transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-white/50 leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Accent Line */}
                <div className="absolute bottom-0 left-0 w-0 h-px bg-accent group-hover:w-full transition-all duration-500" />
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
